import React, { cloneElement, useEffect, useState } from 'react';
import { Avatar, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import AppFormatAmount from '../../../../app/features/format/AppFormatAmount';

import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import HAppRoutes from '../../../../app/features/routes/helpers/HAppRoutes';
import InvestorRoutes from '../../InvestorRoutes';
import CAppPaper from '../../../../app/components/CAppPaper';
import investmentActionLang from '../../langs/investmentActionLang';
import AppCustomIcon from '../../../../app/features/icon/AppIcon';
import IFundType from '../../interfaces/expertise/IFundType';
import useInvestExpertises from '../../hooks/expertise/useInvestExpertises';
import { TInvestFundCurrency } from '../../types/fund/TInvestFundCurrency';

type CTypeInvestmentItemProps = {
	investmentTypeTag: string;
	amount: number;
	currency: TInvestFundCurrency;
};

const CTypeInvestmentItem = (props: CTypeInvestmentItemProps) => {
	const { investmentTypeTag, amount, currency } = props;

	const { t } = useTranslation();

	const theme = useTheme();
	const navigate = useNavigate();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const investExpertises = useInvestExpertises();

	const [mapping, setMapping] = useState<IFundType>();
	useEffect(() => {
		if (investmentTypeTag && investExpertises) {
			const mapFundTypesTmp = investExpertises.find((x) => x.tag === investmentTypeTag);
			setMapping(mapFundTypesTmp);
		}
	}, [investExpertises, investmentTypeTag]);

	const handleExplore = () => {
		navigate(HAppRoutes.getPath(InvestorRoutes.fund_type.tag, { investExpertiseTag: investmentTypeTag }));
	};

	return (
		<>
			{mapping ? (
				<CAppPaper
					className="expertise-item"
					id={`expertise-item-${investmentTypeTag}`}
					color="default"
					variant="outlined"
					style={{
						cursor: 'pointer',
						padding: isMobile ? '15px' : '20px',
					}}
					onClick={() => handleExplore()}
				>
					<Grid container spacing={0} margin={0} alignItems="center">
						<Grid item xs={3} sm={3}>
							<Avatar
								sx={{
									width: isMobile ? '47px' : '60px',
									height: isMobile ? '47px' : '60px',

									backgroundColor: 'rgba(42, 189, 187, 0.15)',
								}}
							>
								{cloneElement(mapping.icon, {
									style: {
										width: '34px',
										height: '34px',
										color:
											theme.palette.mode === 'dark'
												? theme.palette.secondary.main
												: theme.palette.primary.main,
									},
								})}
							</Avatar>
						</Grid>
						<Grid item xs={9} sm={9} style={{ display: 'flex', flexDirection: 'column' }}>
							<div style={{ position: 'relative' }}>
								<Link
									color="primary"
									to={HAppRoutes.getPath(InvestorRoutes.fund_type.tag, {
										investExpertiseTag: investmentTypeTag,
									})}
									style={{
										textDecoration: 'none',
										position: 'absolute',
										right: '0px',
										fontFamily: "'Poppins'",
										fontStyle: 'normal',
										fontWeight: '500',
										fontSize: '0.9rem',
										lineHeight: '1.5',
										display: 'inline-block',
										color: theme.palette.mode === 'dark' ? '#FFF' : theme.palette.primary.main,
									}}
								>
									<AppCustomIcon tag="arrow-right" style={{ verticalAlign: 'middle' }} />{' '}
									{isMobile ? '' : t(investmentActionLang.explore.tag)}
								</Link>
								<Typography
									variant="h3"
									component="h3"
									style={{
										margin: '0px',
										fontFamily: "'Poppins'",
										fontStyle: 'normal',
										fontWeight: '600',
										fontSize: '1rem',
										lineHeight: '1.5',
									}}
								>
									{t(mapping.name)}
								</Typography>
								<Typography
									color="primary"
									style={{
										margin: '0px',
										fontFamily: "'Poppins'",
										fontStyle: 'normal',
										fontWeight: '600',
										fontSize: '1.875rem',
										lineHeight: '1.5',
									}}
								>
									<AppFormatAmount value={amount} addSpace currency={currency} />
								</Typography>
							</div>
						</Grid>
					</Grid>
				</CAppPaper>
			) : (
				''
			)}
		</>
	);
};

export default CTypeInvestmentItem;
